import React from 'react';
import MainConfig from './MainConfig';
import AxisConfig from '../AxisConfig';
import SeriesConfig from '../SeriesConfig';
import HorizontalAxisConfig from './HorizontalAxisConfig';

export const DEFAULT_CONFIGURATION = {
  chartTitle: '',
  legendAnchor: 'bottom-right',
  pointSize: 'small',
  showLabels: true,
  trendline: false,
  horizontalAxis: {
    enabled: true,
    title: '',
    labelSlant: 0,
  },
  verticalAxis: {
    enabled: true,
    title: '',
    labelSlant: 0,
  },
  scale: 1,
  axisPrefix: null,
  axisSuffix: null,
  secondaryAxisPrefix: null,
  secondaryAxisSuffix: null,
  minValue: null,
  maxValue: null,
  horizontalMinValue: null,
  horizontalMaxValue: null,
  useDataColor: true,
  colors: {},
  backgroundColor: 'transparent',
  gridColor: 'transparent',
};

function ScatterPlotConfiguration({ meta, horizontalSortType }) {
  return (
    <>
      <MainConfig />
      <HorizontalAxisConfig horizontalSortType={horizontalSortType} />
      <AxisConfig axis='vertical' active />
      <SeriesConfig meta={meta} />
    </>
  );
}

export default ScatterPlotConfiguration;
